"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoMakerAppPreLoad = exports.biLogger = void 0;
var tslib_1 = require("tslib");
var web_bi_logger_1 = tslib_1.__importDefault(require("@wix/web-bi-logger"));
exports.biLogger = web_bi_logger_1.default
    .factory({ endpoint: 'video-maker' })
    .updateDefaults({
    src: 84,
})
    .logger();
function videoMakerAppPreLoad(_a) {
    var isFirst = _a.isFirst, metaSiteId = _a.metaSiteId, origin = _a.origin, sessionId = _a.sessionId, source = _a.source, context = _a.context;
    exports.biLogger
        .log({
        evid: 200,
        isFirst: isFirst,
        msid: metaSiteId,
        origin: origin,
        sessionId: sessionId,
        source: source,
        context: context,
    })
        .catch(function (error) {
        throw new Error(error);
    });
}
exports.videoMakerAppPreLoad = videoMakerAppPreLoad;
//# sourceMappingURL=biLogger.js.map